import { render } from "./IconCopyLink.vue?vue&type=template&id=eb910084"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCopyLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb910084"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb910084', __exports__)) {
    api.reload('eb910084', __exports__)
  }
  
  module.hot.accept("./IconCopyLink.vue?vue&type=template&id=eb910084", () => {
    api.rerender('eb910084', render)
  })

}


export default __exports__